module.exports = __webpack_public_path__ + "img/ta-hj-rightTitle02.5ca94ac2.png";